import { saveAs } from "file-saver";
import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import SelectAll from "../controls/selectall";
import Translation from "../translation/translation";

class RecapForPeriodReport extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.DeliveriesPage = 0;
        this.PageSize = 10;
        if (!Context.IsLogged()) {
            return;
        }
        this.sid = Context.GetContext().Sid;

        this.state = {
            FromDate: moment().startOf("day"),
            ToDate: moment().endOf("day"),
            result: ""
        };

        this.Report = this.Report.bind(this);
        this.ChangeStartDate = this.ChangeStartDate.bind(this);
        this.ChangeEndDate = this.ChangeEndDate.bind(this);

    }
    Report() {
        let rep = Comm.CallGetServerFunction("shop/fd_recap_period", {
            session: this.sid,
            from: moment(this.state.FromDate).format("YYYYMMDD"),
            to: moment(this.state.ToDate).format("YYYYMMDD"),
        });
        this.setState({ result: rep.html || "" })

    }

    ChangeStartDate(date) {
        this.setState({ FromDate: date });
    }

    ChangeEndDate(date) {
        this.setState({ ToDate: date });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;
        let self = this;

        return Context.HasRight("rrecapperiodreport") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("recapperiodreport")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-3">
                            <Datetime
                                inputProps={{
                                    placeholder: "N/A",
                                    readOnly: true,
                                    className: "form-control pointhand",
                                }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={this.ChangeStartDate}
                                value={this.state.FromDate}
                                closeOnSelect="true"
                            ></Datetime>
                        </div>
                        <div className="col-md-3">
                            <Datetime
                                inputProps={{
                                    placeholder: "N/A",
                                    readOnly: true,
                                    className: "form-control pointhand",
                                }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={this.ChangeEndDate}
                                value={this.state.ToDate}
                                closeOnSelect="true"
                            ></Datetime>
                        </div>
                        <div className="col-md-3">
                            <button
                                type="button"
                                className="btn btn-default"
                                onClick={() => self.Report()}
                            >
                                {Translation.Trans("report")}
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12" dangerouslySetInnerHTML={{ __html: this.state.result }}>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default RecapForPeriodReport;



// WEBPACK FOOTER //
// ./src/pages/recapperiodreport.js